import React, { useState, useEffect } from "react";
import "../Login.scss";
import { doPasswordReset } from "../../../services/firebase/auth";
import FeatherIcon from "feather-icons-react";
import Warning from "../../../components/_default/Warning";
import { Link } from "react-router-dom";
import Button from "../../../components/_default/Button";

function PasswordReset({ t, history }) {
  const [email, setEmail] = useState("");
  const [wrongField, setWrongField] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);

  const onSubmit = () => {
    setLoading(true);
    var emailRegex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (emailRegex.test(email) === false) {
      setWrongField("This is not an email address.");
      hideErrorPopup();
      setLoading(false);
    } else {
      setWrongField(false);
      doPasswordReset(email, (callback) => {
        if (callback && callback.status && callback.status === "error") {
          setWrongField(callback.error.message);
          hideErrorPopup();
        } else {
          setSuccessMsg(true);
        }
        setLoading(false);
      });
    }
  };

  const hideErrorPopup = () => {
    setTimeout(() => {
      setWrongField(false);
    }, 5000);
  };

  useEffect(() => {
    setEmail(history.location.resetEmail != null ? history.location.resetEmail : "");
  }, []);

  return (
    <>
      <section className="c-login">
        <div className="c-login-wrapper">        
          {successMsg ? (
            <>
              <h1>Link sent</h1>
              <p>You have received an e-mail to change your password, please check your spam folder.</p>
            </>
          ) : (
            <h1>Reset Password</h1>
          )}
          {!successMsg && (
            <>
              <input className="c-input" type="text" placeholder="Email" value={email} onKeyUp={(e) => e.key === "Enter" ? onSubmit() : {}} onChange={(e) => { setEmail(e.target.value); }} />
              <Button className="c-login-btn" text="Reset wachtwoord" loading={loading} onSubmit={() => onSubmit()} />
            </>
          )}
        </div>
      </section>
      <Link to="/login" className="c-forgot-link">
            Login to your account.
          </Link>
      {wrongField && <Warning title="Something went wrong..." wrongField={wrongField} />}
    </>
  );
}

export default PasswordReset;
